import { render, staticRenderFns } from "./introductionModle.vue?vue&type=template&id=332b64ee&scoped=true"
import script from "./introductionModle.vue?vue&type=script&lang=js"
export * from "./introductionModle.vue?vue&type=script&lang=js"
import style0 from "./introductionModle.vue?vue&type=style&index=0&id=332b64ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "332b64ee",
  null
  
)

export default component.exports